// React Components
import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';

// Ant Design Components
import { CaretDownOutlined, EditOutlined, LoadingOutlined, MailOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { Dropdown, Menu, Popconfirm } from 'antd';

// FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faPrint } from '@fortawesome/free-solid-svg-icons';

// Utilities & Helpers
import Helpers from '../../../../../../apis/helpers';
import dropDownMenu from './helpers';

// UI Components
import H3Text from '../../../../../../uilib/h3Text';
import H3Image from '@Uilib/h3Image';

// Images
import Crown from '@Images/crown2.png';
import zohoIcon from '@Images/admin/integrations/zoho-books.png';
import TallyPrime from '@Images/admin/integrations/tally-prime.png';
import Busy from '@Images/admin/integrations/busy.png';

// Common Components
import DownloadLabels from '../../../../../Common/DownloadLabels';
import PRZDrawer from '../../../../../Common/UI/PRZDrawer';
import SendWhatsapp from '../../../../../Common/ViewPurchaseOrder/SendWhatsapp';

// GRN & Related
import GrnMail from '../GrnMail';

// Payment Components
import RecordOutgoingPayment from '../../../../../Payments/RecordPayment/RecordOutgoingPayment';
import LinkOutgoingPayment from '../../../../../Payments/LinkPayment/LinkOutgoingPayment';

// Purchase Components
import DebitNoteForm from '../../../../DebitNotes/DebitNoteForm';
import AccountPayableInvoiceForm from '../../../../AccountPayableInvoice/AccountPayableInvoiceForm';

// Inventory Components
import PrintBarcodes from '../../../../../Inventory/PrintBarcodes';

const ViewGRNHeader = ({
  selectedGRN, destinationTenantId, user, downloadDocument, isLabelAvailable, setState, isQuickView, updateGRNStatus, getGRNById, selectedGrnId, callback, match, updateGRNStatusLoading, deleteGrn, deleteGrnLoading, showGrnAndLabelDropDown, selectedRows, isApInvoiceEnabled, syncGRN, syncGRNLoading, getDownloadQualityChecks, syncTallyGRN, syncTallyGRNLoading, pullTallyVendorPayment, pushGrnToBusy, updatedGstNumber, getPaymentsOutgoingSuccess, history,
}) => {
  const [currentUpdate, setCurrentUpdate] = useState('');
  const [isGenerateLabelModalOpen, setIsGenerateLabelModalOpen] = useState(false);
  const [showEmailDrawer, setShowEmailDrawer] = useState(false);
  const [showWhatsappDrawer, setShowWhatsappDrawer] = useState(false);
  const [showPrintBarcodeDrawer, setShowPrintBarcodeDrawer] = useState(false);
  const [showDnForm, setShowDnForm] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [linkPayment, setLinkPayment] = useState(false);
  const [showApInvoiceForm, setShowApInvoiceForm] = useState(false);

  const isTallyConnected = (selectedGRN?.tenant_info?.tally_configuration?.purchase_voucher_integration) && (['ISSUED', 'VOID'].includes(selectedGRN?.status)) && (selectedGRN?.grn_entity_type !== 'INVENTORY_TRANSFER');

  const menu = dropDownMenu({
    user,
    selectedGRN,
    downloadDocument,
    isLabelAvailable,
    setIsGenerateLabelModalOpen,
  });

  return (
    <React.Fragment>
      <div className="view-document__title">
        <div className="view-document__title-number-wrapper">
          <H3Text text={selectedGRN?.grn_number} className="view-document__title-number" />
          <div className="view-document__title-status" style={{ backgroundColor: Helpers.getStatusColor(selectedGRN?.status).color }}>
            {selectedGRN?.status?.replaceAll('_', ' ')}
          </div>
        </div>
        {destinationTenantId && destinationTenantId === user?.tenant_info?.tenant_id ? (
          <div className="view-document__title-actions">
            <div className="action-buttons">
              {['DRAFT'].includes(selectedGRN?.status) && Helpers.getPermission(Helpers.permissionEntities?.GOOD_RECEIVING, Helpers.permissionTypes.UPDATE, user) && !selectedGRN?.subcontractor_mo_id && (
                <H3Text
                  text={(
                    <Link to={`/purchase/goods-receiving/update/${selectedGRN?.grn_id}`}>
                      <EditOutlined />
                    </Link>
                  )}
                  className="action-button"
                />
              )}

              <Dropdown overlay={menu} trigger={['click']}>
                <div
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                  }}
                  className="action-button"
                >
                  <FontAwesomeIcon icon={faPrint} style={{ fontSize: '16px' }} />
                </div>
              </Dropdown>

            </div>
            {!isQuickView && (
              <div className="action-buttons">
                {Helpers.getPermission(Helpers.permissionEntities?.GOOD_RECEIVING,
                  Helpers.permissionTypes.CREATE, user) && selectedGRN?.status.toUpperCase() === 'DRAFT'
                  && (
                    <Popconfirm
                      placement="topRight"
                      title="Are you sure you want to issue this GRN?"
                      onConfirm={() => {
                        setCurrentUpdate('SENT_FOR_APPROVAL');
                        updateGRNStatus({
                          grn_id: selectedGRN?.grn_id,
                          status: 'SENT_FOR_APPROVAL',
                        }, () => {
                          setCurrentUpdate('');
                          setState({ showModal: true });
                          getGRNById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ).join(','), selectedGrnId || match?.params?.grnId);
                          if (callback) callback();
                        });
                      }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <H3Text
                        text={(
                          <div>
                            {(currentUpdate === 'SENT_FOR_APPROVAL' && updateGRNStatusLoading)
                              ? <LoadingOutlined /> : (
                                <span>Issue GRN</span>
                              )}
                          </div>
                        )}
                        className="action-button action-button-big"
                      />
                    </Popconfirm>
                  )}

                {Helpers.getPermission(Helpers.permissionEntities.GOOD_RECEIVING,
                  Helpers.permissionTypes.DELETE, user) && !selectedGRN?.grn_payments?.length
                  && selectedGRN?.status.toUpperCase() !== 'VOID' && selectedGRN?.status.toUpperCase() !== 'REJECTED'
                  && (
                    <Popconfirm
                      placement="topRight"
                      title="Are you sure you want to cancel this GRN?"
                      onConfirm={() => {
                        setCurrentUpdate('VOID');
                        updateGRNStatus({
                          grn_id: selectedGRN?.grn_id,
                          grn_tenant_id: selectedGRN?.grn_tenant_id,
                          grn_entity_type: 'PURCHASE_ORDER',
                          status: 'VOID',
                        }, () => {
                          setCurrentUpdate('');
                          getGRNById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ).join(','), selectedGrnId || match?.params?.grnId);
                          if (callback) callback();
                        });
                      }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <H3Text
                        text={(
                          <div>
                            {(currentUpdate === 'VOID' && updateGRNStatusLoading)
                              ? <LoadingOutlined /> : (
                                <span>Cancel</span>
                              )}
                          </div>
                        )}
                        className="action-button action-button-big"
                      />
                    </Popconfirm>
                  )}
                {Helpers.getPermission(Helpers.permissionEntities.GOOD_RECEIVING,
                  Helpers.permissionTypes.DELETE, user)
                  && !selectedGRN?.grn_payments?.length
                  && (
                    <Popconfirm
                      placement="topRight"
                      title="Are you sure you want to delete this GRN permanently?"
                      onConfirm={() => {
                        setCurrentUpdate('DELETE');
                        deleteGrn(selectedGRN?.grn_tenant_id, selectedGRN?.grn_id, () => {
                          setCurrentUpdate('');
                          if (callback) { callback(); } else {
                            history.push('/purchase/goods-receiving/');
                          }
                        });
                      }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <H3Text
                        text={(
                          <div>
                            {(currentUpdate === 'DELETE' && deleteGrnLoading) ? <LoadingOutlined /> : (
                              <span>Delete</span>
                            )}
                          </div>
                        )}
                        className="action-button action-button-big"
                      />
                    </Popconfirm>
                  )}
              </div>
            )}
          </div>
        ) : (
          <div className="view-document__title-actions">
            <div className="action-buttons">
              {['DRAFT'].includes(selectedGRN?.status) && Helpers.getPermission(Helpers.permissionEntities?.GOOD_RECEIVING, Helpers.permissionTypes.UPDATE, user) && !selectedGRN?.subcontractor_mo_id && (
                <H3Text
                  text={(
                    <Link to={`/purchase/goods-receiving/update/${selectedGRN?.grn_id}`}>
                      <EditOutlined />
                    </Link>
                  )}
                  className="action-button"
                />
              )}
              {Helpers.getPermission(Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.UPDATE, user) && selectedGRN?.status === 'ISSUED' && (
                <H3Text
                  text={(
                    <div onClick={() => setShowEmailDrawer(true)}>
                      <MailOutlined />
                    </div>
                  )}
                  className="action-button"
                />
              )}
              {user?.tenant_info?.integration_config?.sub_modules?.whatsapp?.is_active && user?.tenant_info?.integration_tenant_whatsapp_id && Helpers.getPermission(Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.UPDATE, user) && selectedGRN?.status === 'ISSUED' && (
                <H3Text
                  text={(
                    <div onClick={() => setShowWhatsappDrawer(true)}>
                      <WhatsAppOutlined />
                    </div>
                  )}
                  className="action-button"
                />
              )}

              <Dropdown overlay={menu} trigger={['click']} getPopupContainer={(triggerNode) => (showGrnAndLabelDropDown ? triggerNode.parentNode : document.body)} placement={showGrnAndLabelDropDown ? 'topLeft' : 'bottomLeft'}>
                <div style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                }}
                >
                  <FontAwesomeIcon icon={faPrint} style={{ fontSize: '16px' }} />
                </div>
              </Dropdown>
              {selectedRows?.length > 0 && user?.tenant_info?.global_config?.sub_modules?.barcoding?.is_active && (
                <H3Text
                  text={(
                    <Fragment>
                      Print Barcodes
                      &nbsp;
                      <FontAwesomeIcon icon={faBarcode} />
                    </Fragment>
                  )}
                  className="action-button action-button-big"
                  onClick={() => setShowPrintBarcodeDrawer(true)}
                />
              )}
            </div>
            {!isQuickView && (
              <div className="action-buttons">
                {Helpers.getPermission(Helpers.permissionEntities?.GOOD_RECEIVING,
                  Helpers.permissionTypes.CREATE, user) && selectedGRN?.status.toUpperCase() === 'DRAFT'
                  && (
                    <Popconfirm
                      placement="topRight"
                      title="Are you sure you want to issue this GRN?"
                      onConfirm={() => {
                        setCurrentUpdate('ISSUED');
                        updateGRNStatus({
                          grn_id: selectedGRN?.grn_id,
                          status: 'ISSUED',
                        }, () => {
                          setCurrentUpdate('');
                          if (user?.tenant_info?.seller_rating_config?.is_active) {
                            setState({ showModal: true });
                          } else {
                            getGRNById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ).join(','), selectedGrnId || match?.params?.grnId);
                            if (callback) callback();
                          }
                        });
                      }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <H3Text
                        text={(
                          <div>
                            {(currentUpdate === 'ISSUED' && updateGRNStatusLoading)
                              ? <LoadingOutlined /> : (
                                <span>Issue GRN</span>
                              )}
                          </div>
                        )}
                        className="action-button action-button-big"
                      />
                    </Popconfirm>
                  )}

                {Helpers.getPermission(Helpers.permissionEntities.GOOD_RECEIVING,
                  Helpers.permissionTypes.CREATE, user) && !selectedGRN?.grn_payments?.length
                  && selectedGRN?.status.toUpperCase() !== 'VOID' && selectedGRN?.status.toUpperCase() !== 'REJECTED'
                  && (
                    <Popconfirm
                      placement="topRight"
                      title="Are you sure you want to cancel this GRN?"
                      onConfirm={() => {
                        setCurrentUpdate('VOID');
                        updateGRNStatus({
                          grn_id: selectedGRN?.grn_id,
                          grn_tenant_id: selectedGRN?.grn_tenant_id,
                          grn_entity_type: 'PURCHASE_ORDER',
                          status: 'VOID',
                        }, () => {
                          setCurrentUpdate('');
                          getGRNById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ).join(','), selectedGrnId || match?.params?.grnId);
                          if (callback) callback();
                        });
                      }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <H3Text
                        text={(
                          <div>
                            {(currentUpdate === 'VOID' && updateGRNStatusLoading)
                              ? <LoadingOutlined /> : (
                                <span>Cancel</span>
                              )}
                          </div>
                        )}
                        className="action-button action-button-big"
                      />
                    </Popconfirm>
                  )}
                {Helpers.getPermission(Helpers.permissionEntities.GOOD_RECEIVING,
                  Helpers.permissionTypes.DELETE, user) && !selectedGRN?.grn_payments?.length
                  && selectedGRN?.status.toUpperCase() === 'VOID'
                  && (
                    <Popconfirm
                      placement="topRight"
                      title="Are you sure you want to delete this GRN permanently?"
                      onConfirm={() => {
                        setCurrentUpdate('DELETE');
                        deleteGrn(selectedGRN?.grn_tenant_id, selectedGRN?.grn_id, () => {
                          setCurrentUpdate('');
                          if (callback) { callback(); } else {
                            history.push('/purchase/goods-receiving/');
                          }
                        });
                      }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <H3Text
                        text={(
                          <div>
                            {(currentUpdate === 'DELETE' && deleteGrnLoading) ? <LoadingOutlined /> : (
                              <span>Delete</span>
                            )}
                          </div>
                        )}
                        className="action-button action-button-big"
                      />
                    </Popconfirm>
                  )}

                {user?.user_tenants?.find((item) => item?.tenant_id === selectedGRN?.tenant_info?.tenant_id)?.zoho_branch_id && selectedGRN?.seller_id && ['ISSUED', 'VOID'].includes(selectedGRN?.status) && !isApInvoiceEnabled && (
                  <Popconfirm
                    placement="topRight"
                    title="Sync with Zoho Books?"
                    onConfirm={() => {
                      if (!syncGRNLoading) {
                        syncGRN({ grn_id: selectedGRN?.grn_id },
                          () => getGRNById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ).join(','), selectedGrnId || match?.params?.grnId));
                      }
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <div className="action-button action-button-big">
                      <H3Image src={zohoIcon} className="action-menu-button-icon-zoho" />
                      &nbsp;
                      <H3Text text="Sync" />
                    </div>
                  </Popconfirm>
                )}

                {selectedGRN?.status === 'ISSUED' && window.screen.width > 425 && (
                  <Dropdown
                    overlay={(
                      <Menu>
                        {Helpers.getPermission(Helpers.permissionEntities.DEBIT_NOTE,
                          Helpers.permissionTypes.CREATE, user) && selectedGRN?.status.toUpperCase() === 'ISSUED' && window.screen.width > 425 && !isApInvoiceEnabled && (
                          <Menu.Item>
                            <H3Text
                              text={(
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <div>
                                      + Debit Note
                                  </div>
                                  {!user?.tenant_info?.purchase_config?.sub_modules?.debit_note?.is_active && (
                                    <Popconfirm
                                      placement="topRight"
                                      title="This feature is not accessible within your current plan to use this feature contact us."
                                      onConfirm={() => globalThis.Intercom('showNewMessage')}
                                      okText="Contact Us"
                                      cancelText="Cancel"
                                    >
                                      <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                    </Popconfirm>
                                  )}
                                </div>
                              )}
                              onClick={() => {
                                if (user?.tenant_info?.purchase_config?.sub_modules?.debit_note?.is_active) {
                                  setShowDnForm(true);
                                }
                              }}
                              className="action-menu-button"
                            />
                          </Menu.Item>
                        )}
                        {Helpers.getPermission(Helpers.permissionEntities.VENDOR_PAYOUT,
                          Helpers.permissionTypes.CREATE, user) && selectedGRN?.status.toUpperCase() === 'ISSUED' && (selectedGRN?.grn_grand_total - selectedGRN?.total_payment_made) > 0 && !isApInvoiceEnabled
                          && (
                            <Menu.Item>
                              <H3Text
                                text={(
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                      Record Payment
                                    </div>
                                    {!user?.tenant_info?.purchase_config?.sub_modules?.payment_outgoing?.is_active && (
                                      <Popconfirm
                                        placement="topRight"
                                        title="This feature is not accessible within your current plan to use this feature contact us."
                                        onConfirm={() => globalThis.Intercom('showNewMessage')}
                                        okText="Contact Us"
                                        cancelText="Cancel"
                                      >
                                        <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                      </Popconfirm>
                                    )}
                                  </div>
                                )}
                                onClick={
                                  () => setShowPayment(true)
                                }
                                className="action-menu-button"
                              />
                            </Menu.Item>
                          )}
                        {Helpers.getPermission(Helpers.permissionEntities.VENDOR_PAYOUT,
                          Helpers.permissionTypes.CREATE, user) && selectedGRN?.status.toUpperCase() === 'ISSUED' && (selectedGRN?.grn_grand_total - selectedGRN?.total_payment_made) > 0
                          && window.screen.width > 425 && !isApInvoiceEnabled && (
                          <Menu.Item>
                            <H3Text
                              text={(
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <div>
                                      Link Payment
                                  </div>
                                  {!user?.tenant_info?.purchase_config?.sub_modules?.payment_outgoing?.is_active && (
                                    <Popconfirm
                                      placement="topRight"
                                      title="This feature is not accessible within your current plan to use this feature contact us."
                                      onConfirm={() => globalThis.Intercom('showNewMessage')}
                                      okText="Contact Us"
                                      cancelText="Cancel"
                                    >
                                      <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                    </Popconfirm>
                                  )}
                                </div>
                              )}
                              onClick={() => setLinkPayment(true)}
                              className="action-menu-button"
                            />
                          </Menu.Item>
                        )}
                        {['ISSUED'].includes(selectedGRN?.status) && (selectedGRN?.grn_quality_checks) && (
                          <Menu.Item>
                            <div
                              className="action-menu-button-inline"
                              onClick={() => {
                                getDownloadQualityChecks(selectedGRN?.grn_tenant_id, '', 'GOOD_RECEIVING_NOTE', selectedGRN?.grn_id), () => {
                                  getGRNById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ).join(','), selectedGrnId || match?.params?.grnId);
                                };
                              }}
                            >
                              <H3Text
                                text="Download QC Report"
                                className="action-menu-button"
                              />
                            </div>
                          </Menu.Item>
                        )}
                        {isTallyConnected && !isApInvoiceEnabled && (
                          <Menu.Item>
                            <div
                              className="action-menu-button-inline"
                              onClick={() => {
                                if (user?.tenant_info?.integration_config?.sub_modules?.tally?.is_active) {
                                  syncTallyGRN({ grn_id: selectedGrnId || match?.params?.grnId },
                                    () => {
                                      if (selectedGRN?.tally_updated_at) {
                                        pullTallyVendorPayment({ seller_id: selectedGRN?.seller_id, tenant_id: selectedGRN?.tenant_info?.tenant_id });
                                      }
                                      getGRNById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ).join(','), selectedGrnId || match?.params?.grnId);
                                    });
                                }
                              }}
                            >
                              <H3Image src={TallyPrime} className="action-menu-button-icon" />
                              <H3Text
                                text={(
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                      Push with Tally
                                    </div>
                                    {!user?.tenant_info?.integration_config?.sub_modules?.tally?.is_active && (
                                      <Popconfirm
                                        placement="topRight"
                                        title="This feature is not accessible within your current plan to use this feature contact us."
                                        onConfirm={() => globalThis.Intercom('showNewMessage')}
                                        okText="Contact Us"
                                        cancelText="Cancel"
                                      >
                                        <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                      </Popconfirm>
                                    )}
                                  </div>
                                )}
                                className="action-menu-button"
                              />
                            </div>
                          </Menu.Item>
                        )}

                        {selectedGRN?.integration_busy_config?.status === 'CONNECTED' && ['ISSUED'].includes(selectedGRN?.status) && !isApInvoiceEnabled && (
                          <Menu.Item>
                            <div
                              className="action-menu-button-inline"
                              onClick={() => {
                                if (user?.tenant_info?.integration_config?.sub_modules?.busy?.is_active) {
                                  pushGrnToBusy({
                                    grn_id: selectedGRN?.grn_id,
                                  }, () => {
                                    getGRNById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ).join(','), selectedGrnId || match?.params?.grnId);
                                  });
                                }
                              }}
                            >
                              <H3Image
                                src={Busy}
                                className="action-menu-button-icon"
                                style={{
                                  borderRadius: '20%',
                                }}
                              />
                              <H3Text
                                text={(
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                      Push To Busy
                                    </div>
                                    {!user?.tenant_info?.integration_config?.sub_modules?.tally?.is_active && (
                                      <Popconfirm
                                        placement="topRight"
                                        title="This feature is not accessible within your current plan to use this feature contact us."
                                        onConfirm={() => globalThis.Intercom('showNewMessage')}
                                        okText="Contact Us"
                                        cancelText="Cancel"
                                      >
                                        <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                      </Popconfirm>
                                    )}
                                  </div>
                                )}
                                className="action-menu-button"
                              />
                            </div>
                          </Menu.Item>
                        )}
                        {Helpers.getPermission(Helpers.permissionEntities.ACCOUNT_PAYABLE_INVOICE,
                          Helpers.permissionTypes.CREATE, user) && selectedGRN?.status.toUpperCase() === 'ISSUED' && window.screen.width > 425 && isApInvoiceEnabled
                          && (
                            <Menu.Item>
                              <H3Text
                                text={(
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                      + AP Invoice
                                    </div>
                                    {!user?.tenant_info?.purchase_config?.sub_modules?.account_payable_invoice?.is_active && (
                                      <Popconfirm
                                        placement="topRight"
                                        title="This feature is not accessible within your current plan to use this feature contact us."
                                        onConfirm={() => globalThis.Intercom('showNewMessage')}
                                        okText="Contact Us"
                                        cancelText="Cancel"
                                      >
                                        <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                      </Popconfirm>
                                    )}
                                  </div>
                                )}
                                onClick={() => {
                                  if (user?.tenant_info?.purchase_config?.sub_modules?.account_payable_invoice?.is_active) {
                                    setShowApInvoiceForm(true);
                                  }
                                }}
                                className="action-menu-button"
                              />
                            </Menu.Item>
                          )}
                      </Menu>
                    )}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    trigger={['click']}
                    overlayStyle={{ width: '150px' }}
                    placement="topLeft"
                  >
                    <div className="action-button action-button-big action-button-more no-right-border" onClick={(e) => e.preventDefault()}>
                      More
                      <CaretDownOutlined />
                    </div>
                  </Dropdown>
                )}
              </div>
            )}
          </div>
        )}
      </div>
      <DownloadLabels
        documentType="good_receiving_note"
        documentId={selectedGRN?.grn_id}
        isModalOpen={isGenerateLabelModalOpen}
        toggleModal={() => {
          setIsGenerateLabelModalOpen(!isGenerateLabelModalOpen);
        }}
        setIsLabelAvailable={(val) => setState({ isLabelAvailable: val })}
        selectedGRN={selectedGRN}
      />

      <PRZDrawer
        open={showEmailDrawer}
        width="420px"
        headerWidth="370px"
        mask
        onClose={() => setShowEmailDrawer(false)}
        title="Send GRN Notification"
      >
        <GrnMail selectedEntity={selectedGRN} callback={() => setShowEmailDrawer(false)} />
      </PRZDrawer>

      <PRZDrawer
        open={showWhatsappDrawer}
        width="360px"
        headerWidth="310px"
        mask
        onClose={() => setShowWhatsappDrawer(false)}
        title="Share on Whatsapp"
      >
        <SendWhatsapp selectedEntity={selectedGRN} entityName="grn" callback={() => setShowWhatsappDrawer(false)} />
      </PRZDrawer>

      <PRZDrawer
        open={showPrintBarcodeDrawer}
        width="360px"
        headerWidth="310px"
        mask
        onClose={() => setShowPrintBarcodeDrawer(false)}
        title="Print Barcodes"
      >
        <PrintBarcodes selectedRows={selectedRows} barcodeType="GRN" />
      </PRZDrawer>

      <PRZDrawer
        open={showDnForm}
        width="77.5%"
        headerWidth='calc(77.5% - 50px)'
        onClose={() => setShowDnForm(false)}
        title={'Create Debit Note'}
      >
        <DebitNoteForm
          selectedGrnForDN={{
            ...selectedGRN,
            tenant_seller_info: {
              ...((selectedGRN && selectedGRN.tenant_seller_info) || {}),
              gst_number: updatedGstNumber,
            },
          }}
          callback={() => {
            setShowDnForm(false);
            getGRNById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ).join(','), selectedGrnId || match?.params?.grnId);
          }}
          isQuickView
        />
      </PRZDrawer>

      <PRZDrawer
        open={showPayment}
        width="420px"
        headerWidth="375px"
        onClose={() => setShowPayment(false)}
        title={'Record New Payment'}
      >
        <RecordOutgoingPayment
          selectedGRN={selectedGRN}
          callback={() => {
            setShowPayment(false);
            getGRNById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ).join(','), selectedGrnId || match?.params?.grnId);
          }}
        />
      </PRZDrawer>

      <PRZDrawer
        open={linkPayment}
        width="820px"
        headerWidth="775px"
        onClose={() => setLinkPayment(false)}
        title={'Link Payment'}
      >
        <LinkOutgoingPayment
          selectedEntity={selectedGRN}
          callback={() => {
            setLinkPayment(false);
            getGRNById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ).join(','), selectedGrnId || match?.params?.grnId);
            getPaymentsOutgoingSuccess(null);
          }}
          screen={'grn'}
        />
      </PRZDrawer>

      <PRZDrawer
        open={showApInvoiceForm}
        width="77.5%"
        headerWidth="calc(77.5% - 50px)"
        onClose={() => setShowApInvoiceForm(false)}
        title={'Create AP Invoice'}
      >
        <AccountPayableInvoiceForm
          selectedGRNForAPInvoice={{
            ...selectedGRN,
            tenant_seller_info: {
              ...((selectedGRN && selectedGRN.tenant_seller_info) || {}),
              gst_number: updatedGstNumber,
            },
          }}
          callback={() => {
            setShowApInvoiceForm(false);
            getGRNById(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.GOOD_RECEIVING, Helpers.permissionTypes.READ).join(','), selectedGrnId || match?.params?.grnId);
          }}
          isQuickView
        />
      </PRZDrawer>

    </React.Fragment>
  )
}

export default ViewGRNHeader